/**
 * ErrorHandlerInitializer Component
 *
 * Initializes the global API error handler with notification context.
 * Must be rendered inside SnackbarProvider to access notification hooks.
 *
 * Provides error handler with:
 * - Toast notification functions (showError, showWarning, showInfo)
 * - Sign out function for auth errors
 * - ErrorDetailsButton component for expandable error info
 *
 * @see src/services/apiErrorHandler.tsx Error handling logic
 */

import { useEffect, useCallback } from 'react';
import { initializeErrorHandler } from 'services/apiErrorHandler';
import { useNotification } from 'hooks/useNotification';
import { ErrorDetailsButton } from 'components/ErrorDetailsButton';
import { useAppDispatch } from 'redux/hooks';
import { signOut } from 'thunk';

export const ErrorHandlerInitializer = () => {
  const { showError, showWarning, showInfo } = useNotification();
  const dispatch = useAppDispatch();

  const handleSignOut = useCallback(() => {
    dispatch(signOut());
  }, [dispatch]);

  useEffect(() => {
    initializeErrorHandler({
      showError,
      showWarning,
      showInfo,
      signOut: handleSignOut,
      ErrorDetailsButton,
    });
  }, [showError, showWarning, showInfo, handleSignOut]);

  return null; // This component doesn't render anything
};
